import React, { useState, useEffect } from "react";
import { IconType } from "react-icons";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useViewInquiryQuery } from "src/services/InquiryServices";
import { FaUser } from "react-icons/fa";
import { RiChatFollowUpLine } from "react-icons/ri";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import InquirySideBarLayoutSideBarLayout from "./InquirySideBarLayout/InquirySideBarLayoutSideBarLayout";
import { CircularProgress } from "@mui/material";

type Props = {};

  export const inquiriesEditTabs: {
    label: string;
    icon: IconType;
    path: string;
    moduleName: string;
    actionName: string;
  }[] = [
    {
      label: "FOLLOWUP",
      icon: RiChatFollowUpLine,
      path: "followup",
      moduleName: UserModuleNameTypes.INQUIRIES,
      actionName: UserModuleActionTypes.INQUIRIES_EDIT_FOLLOWUP,
    },
    {
      label: "DETAILS",
      icon: FaUser,
      path: "details/personal-information",
      moduleName: UserModuleNameTypes.INQUIRIES,
      actionName: UserModuleActionTypes.INQUIRIES_EDIT_DETAILS,
    },
  ];

const InquiryLayout = (props: Props) => {
  const { userType } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const { inquiryId = "" } = useParams();

  const currentPath = location.pathname.split("/")[4];

  //QUERY
  const [inquiryDataState, setInquiryData] = useState<any>();

  const {
    data: inquiryData,
    isLoading: InquiryisLoading,
    isFetching: InquiryisFetching,
  } = useViewInquiryQuery(inquiryId);


  useEffect(() => {
    if (!InquiryisLoading && !InquiryisFetching) {
      setInquiryData(inquiryData?.data);
    }
  }, [inquiryData, InquiryisLoading, InquiryisFetching]);

  return (
    <div className="grid grid-cols-12">
      {(InquiryisLoading || InquiryisFetching) && (
        <div className="absolute w-[75%] h-[75%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
          <CircularProgress />
        </div>
      )}
      <div className="md:col-span-4 xl:col-span-2 xxl:col-span-2">
        <InquirySideBarLayoutSideBarLayout />
      </div>
      <div className="md:col-span-8 xl:col-span-10 xxl:col-span-10">
        <div className="flex flex-col gap-2 pt-3 h-full">
          {/* inquiriesEditTabs */}
          {inquiriesEditTabs?.length && (
            <div className="flex gap-3 items-center  mx-4  border-b border-slate-400 bg-white ">
              {inquiriesEditTabs
                ?.filter((module: any) =>
                  userType === "ADMIN"
                    ? true
                    : isCheckActionsPermission({
                        moduleName: module?.moduleName,
                        actionName: module?.actionName,
                      })
                )
                ?.map((tab: any, index: any) => {
                  return (
                    <div key={index}>
                      <button
                        type="button"
                        onClick={() => navigate(tab.path)}
                        className={`h-full px-5 pb-2 flex gap-2 border-b-[3px]  items-center hover:text-primary-main font-medium text-sm transition-all
        ${
          currentPath === tab.path?.split("/")[0]
            ? "text-primary-main   border-primary-main"
            : "text-gray-700 border-white"
        }
         `}
                      >
                        <div className=" text-lg  ">
                          <tab.icon />
                        </div>
                        {tab?.label}
                      </button>
                    </div>
                  );
                })}
            </div>
          )}

          {/* Outlet */}
          <div className=" flex-1 flex flex-col overflow-auto ">
            <div className="border-b border-slate-300 p-4 ml-3 sticky top-0 md:z-[1000] xs:z-[0] bg-white">
              <div className="flex gap-3">
                {/* Avatar  */}
                <div className="w-[56px] aspect-square rounded bg-primary-main text-white flex justify-center items-center text-2xl font-semibold capitalize ">
                  {inquiryDataState?.name?.[0]}{" "}
                </div>

                <div className="flex flex-col">
                  {/* Name */}
                  <div className="text-primary-dark font-semibold text-xl capitalize">
                    {inquiryDataState?.name}
                  </div>

                  {/* Mobile */}
                  <div className="text-primary-dark d text-slate-600">
                    {inquiryDataState?.mobile}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryLayout;
